import { render, staticRenderFns } from "./InsufficientBalanceDialog.vue?vue&type=template&id=c45d5736"
import script from "./InsufficientBalanceDialog.vue?vue&type=script&lang=js"
export * from "./InsufficientBalanceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_babel-core@7.0.0-bridge.0_@babel+core@7.28._3caa1b14bd3e4846d6b68320ea08bfb3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports